"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenPair = exports.ownerToJSON = exports.ownerFromJSON = exports.Owner = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "Switcheo.carbon.erc20";
/** Owner enumerates the ownership of a ERC20 contract. */
var Owner;
(function (Owner) {
    /** OWNER_UNSPECIFIED - OWNER_UNSPECIFIED defines an invalid/undefined owner. */
    Owner[Owner["OWNER_UNSPECIFIED"] = 0] = "OWNER_UNSPECIFIED";
    /** OWNER_MODULE - OWNER_MODULE - erc20 is owned by the erc20 module account. */
    Owner[Owner["OWNER_MODULE"] = 1] = "OWNER_MODULE";
    /** OWNER_EXTERNAL - OWNER_EXTERNAL - erc20 is owned by an external account. */
    Owner[Owner["OWNER_EXTERNAL"] = 2] = "OWNER_EXTERNAL";
    Owner[Owner["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Owner = exports.Owner || (exports.Owner = {}));
function ownerFromJSON(object) {
    switch (object) {
        case 0:
        case "OWNER_UNSPECIFIED":
            return Owner.OWNER_UNSPECIFIED;
        case 1:
        case "OWNER_MODULE":
            return Owner.OWNER_MODULE;
        case 2:
        case "OWNER_EXTERNAL":
            return Owner.OWNER_EXTERNAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Owner.UNRECOGNIZED;
    }
}
exports.ownerFromJSON = ownerFromJSON;
function ownerToJSON(object) {
    switch (object) {
        case Owner.OWNER_UNSPECIFIED:
            return "OWNER_UNSPECIFIED";
        case Owner.OWNER_MODULE:
            return "OWNER_MODULE";
        case Owner.OWNER_EXTERNAL:
            return "OWNER_EXTERNAL";
        default:
            return "UNKNOWN";
    }
}
exports.ownerToJSON = ownerToJSON;
const baseTokenPair = {
    erc20Address: "",
    denom: "",
    enabled: false,
    contractOwner: 0,
};
exports.TokenPair = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.erc20Address !== "") {
            writer.uint32(10).string(message.erc20Address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.enabled === true) {
            writer.uint32(24).bool(message.enabled);
        }
        if (message.contractOwner !== 0) {
            writer.uint32(32).int32(message.contractOwner);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTokenPair);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.erc20Address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.enabled = reader.bool();
                    break;
                case 4:
                    message.contractOwner = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTokenPair);
        message.erc20Address =
            object.erc20Address !== undefined && object.erc20Address !== null
                ? String(object.erc20Address)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.enabled =
            object.enabled !== undefined && object.enabled !== null
                ? Boolean(object.enabled)
                : false;
        message.contractOwner =
            object.contractOwner !== undefined && object.contractOwner !== null
                ? ownerFromJSON(object.contractOwner)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.erc20Address !== undefined &&
            (obj.erc20Address = message.erc20Address);
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        message.contractOwner !== undefined &&
            (obj.contractOwner = ownerToJSON(message.contractOwner));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseTokenPair);
        message.erc20Address = (_a = object.erc20Address) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.enabled = (_c = object.enabled) !== null && _c !== void 0 ? _c : false;
        message.contractOwner = (_d = object.contractOwner) !== null && _d !== void 0 ? _d : 0;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
